import React from 'react'
import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'

const useStyles = makeStyles((theme) => ({
  customButton: {
    '&:hover': {
      backgroundColor: 'rgba(153, 153, 153, 0.2)',
    },
    borderRadius: '2px',
    padding: '6px 16px',
    minWidth: 88,
  },
  labelStyle: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: '500',
  },
  labelStyleAccent: {
    color: theme.palette.secondary.main,
    fontSize: '14px',
    fontWeight: '500',
  },
  labelStyleRemove: {
    color: theme.palette.error.main,
  },
}))

const TextButton = ({ label, type, fullWidth, color, startIcon, endIcon, onClick, isRecent, onMouseDown, remove = false }) => {
  const classes = useStyles()

  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      color={color}
      className={classes.customButton}
      onClick={onClick}
      onMouseDown={onMouseDown}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      <Typography
        className={`${isRecent === false ? classes.labelStyleAccent : classes.labelStyle} ${
          remove && classes.labelStyleRemove
        }`}
      >
        {label}
      </Typography>
    </Button>
  )
}

export default TextButton
